module.exports = __webpack_public_path__ + "img/borrar.79465718.svg";